export default function fireEREvt(
    event: string,
    contents?: unknown,
    flags?: Record<string, unknown>
) {
    window.eventRecorder = window.eventRecorder || {
        cmd: []
    };

    const current: number = Date.now();

    window.eventRecorder.cmd.push(() => {
        const eventRecorder = window.getEventRecorderClient();

        eventRecorder.fireEvent(event, flags, contents, current);
    });
}
